import { isNotEmpty, handleFormikValueChange } from "../../utils";

type Props = {
  id: string;
  text?: string;
  name?: string;
  disabled?: boolean;
  isSubmitting?: boolean;
  values?: $TSFixMe;
};

function ToggleButton(props: Props) {
  const { id, name, text, disabled, isSubmitting, values } = props;
  const displayText = isNotEmpty(text) ? text : "Unknown";
  const toggleStyle =
    // @ts-expect-error TS(2538) FIXME: Type 'undefined' cannot be used as an index type.
    values && values[name] ? "btn-toggle-on" : "btn-toggle-off";
  const className = `btn-toggle ${toggleStyle}`;

  return (
    <div>
      <button
        id={id}
        name={name}
        className={className}
        // @ts-expect-error TS(2538) FIXME: Type 'undefined' cannot be used as an index type.
        onClick={() => handleFormikValueChange(props, !values[name])}
        disabled={disabled || isSubmitting}
        type="button"
      >
        <span>{displayText}</span>
      </button>
    </div>
  );
}

export default ToggleButton;
